import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'core/api/queryKeys';
import { humanizeApiError } from 'core/errors/mapFieldErrors';
import { useI18n } from 'core/i18n/I18nProvider';
import { userApi } from 'features/home/home.api';
import { Card, ErrorState, Skeleton, StatusChip } from 'shared/components/Feedback';
import { PageMeta } from 'shared/components/PageMeta';
import { formatDateTime, localizedText } from 'shared/utilities/format';

export function TicketDetailPage() {
  const { id } = useParams();
  const { t, locale } = useI18n();
  const query = useQuery({
    queryKey: queryKeys.ticket(id),
    queryFn: () => userApi.ticket(id),
  });

  if (query.isLoading) {
    return <Skeleton rows={5} />;
  }
  if (query.isError) {
    return <ErrorState title={humanizeApiError(query.error, t)} onRetry={() => query.refetch()} retryLabel={t('actions.retry')} />;
  }

  const ticket = query.data || {};
  return (
    <Card>
      <PageMeta titleKey="meta.support" />
      <div className="history-card-head">
        <h1>{ticket.reference}</h1>
        <StatusChip tone={ticket.status}>{ticket.status_label || t(`support.statuses.${ticket.status}`)}</StatusChip>
      </div>
      <p className="muted">{localizedText(ticket.category, locale, ['title', 'name'])}</p>
      <p>{ticket.message}</p>
      <h2>{t('support.response')}</h2>
      <p>{ticket.admin_response || t('support.noResponse')}</p>
      <p className="muted">{formatDateTime(ticket.created_at, locale)}</p>
      {ticket.resolved_at ? <p className="muted">{formatDateTime(ticket.resolved_at, locale)}</p> : null}
    </Card>
  );
}
